<template>
    <div>
        <Boyo-Dialog :dialogInfo="dialogInfoData"
                    @dialogEvent="dialogEventData">
            <el-steps :space="250" align-center :active="activeValue">
                <el-step v-for="(itemf, index) of activeList"
                            :key="index" :title="itemf.processNodeName" :status="itemf.stepStatus || 'process'">
                  <template slot="description">
                    <div v-if="itemf.processNodeName === '制单人'">
                      {{ itemf.approvalTime }}
                    </div>
                    <div v-else>
                      <div style="border-top: 1px solid #e4e7ed; margin: 8px 0;"></div>
                      <div>流程节点：{{ itemf.processNodeName || '' }}</div>
                      <div>经办人：{{ itemf.maker || '' }}</div>
                      <div v-if="itemf.stepStatus !== 'process'">备注：{{ itemf.remark || (itemf.stepStatus === 'success' ? '通过' : '拒绝') }}</div>
                      <div>时间：{{ itemf.makerTime || '' }}</div>
                    </div>
                  </template>
                </el-step>
            </el-steps>
            <Boyo-Formtwo :formInfo="formInfo2"
                    :refObj.sync="formInfo2.ref"
                    :listTypeInfo='listTypeInfo'
                    @handlePictureCardPreview="handlePictureCardPreview">
            </Boyo-Formtwo>
            <el-table :data="tableData"
                    border
                    :summary-method="getSummaries"
                    show-summary
                    max-height="430"
                    style="width: 99%;"
                    :header-cell-style="{background:'rgb(189,215,252)',color:'#3C3C3C',padding:'4px 0'}"
                    :cell-style="{padding:'2px'}">
                    <el-table-column fixed="left"
                    type="index"
                    width="50">
                    </el-table-column>
                <!-- <el-table-column prop="billNoMeterWayCar"
                                align="center"
                                label="过磅单号" width='120px'>
                </el-table-column> -->
                <el-table-column prop="carNo"
                                align="center"
                                label="车牌号" width='80px'>
                </el-table-column>
                <el-table-column prop="containerNumber"
                                align="center"
                                label="柜号" width='80px'>
                </el-table-column>
                    <el-table-column prop="grade"
                                    label="货物品名"
                                    align="center" width='100px'>
                    </el-table-column>
                <el-table-column prop="carNetWeight"
                                align="center"
                                label="到货数量" width='100px'>
                </el-table-column>
                <el-table-column prop="carDeductWeight"
                                align="center"
                                label="扣杂数量" width='60px'>
                </el-table-column>
                <el-table-column prop="settleQuantity"
                                align="center"
                                label="结算数量" width='90px'>
                </el-table-column>
                <el-table-column prop="settleExctTaxPrice"
                                align="center"
                                label="结算单价(不含税)" width="90px">
                </el-table-column>
                <el-table-column prop="settlePrice"
                                align="center"
                                label="结算单价(含税)" width="80px">
                </el-table-column>
                    <el-table-column prop="purOrderPrice"
                                    label="订单单价"
                                    align="center" width="80px">
                    </el-table-column>
                    <el-table-column prop="evaluationPrice"
                                    label="评铁单价"
                                    align="center" width="80px">
                    </el-table-column>
                <el-table-column prop="settleExctTaxAmount"
                                align="center"
                                :label="'结算金额(不含税)/'+amountUnit" width="110px">
                    <template slot-scope="scope">
                    <span>{{scope.row.settleExctTaxAmount?formatAmount(Number(scope.row.settleExctTaxAmount)):''}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="settleAmount"
                                align="center"
                                :label="'结算金额(含税)/'+amountUnit" width="110px">
                    <template slot-scope="scope">
                    <span>{{scope.row.settleAmount?formatAmount(Number(scope.row.settleAmount)):''}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="billDate"
                                align="center"
                                label="到货时间" width="140px">
                </el-table-column>
                <el-table-column prop="billNo"
                                align="center"
                                label="到货单号" width='120px'>
                </el-table-column>
                <el-table-column prop="billNoMeterWayCar" align="center" width="120px"
                                label="过磅单号">
                </el-table-column>
            </el-table>
        </Boyo-Dialog>
        <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="pingImgUrl+dialogImageUrl" alt="">
        </el-dialog>
        <el-dialog :visible.sync="dialogVisible2" class="imgDialog">
            <img width="100%" :src="dialogImageUrl2" alt="">
        </el-dialog>
    </div>
</template>

<script>
import BoyoFilter from '@/components/BoyoFilter'
import BoyoContent from '@/components/BoyoContent'
import BoyoButton from '@/components/BoyoButton'
import BoyoTable from '@/components/BoyoTable'
import BoyoDialog from '@/components/BoyoDialog'
import BoyoForm from '@/components/BoyoForm'
import BoyoFormtwo from '@/components/BoyoFormtwo'
import config from '@/api/config'
export default {
  name: 'WarehousingEntryDialog',
  components: {
    BoyoFilter,
    BoyoContent,
    BoyoButton,
    BoyoTable,
    BoyoDialog,
    BoyoForm,BoyoFormtwo
  },
  props: {},
  data () {
    return {
      activeValue:null,
      activeList:[],
      dataId:'',
      search: {},
      tableData:[],
      detailDate:{},
      billId:'',
      add2:0,
      dialogVisible:false,
      dialogImageUrl:'',
      dialogImageUrl2: '',
      dialogVisible2: false,
      pingImgUrl: config.pingImgUrl,
      amountUnit:localStorage.amountUnit,
      auditParm:{},
      // 下拉框相关信息
      listTypeInfo: {
        purMode :[],
      },
      // 表格相关
      tableInfo: {
        selection: false, // 是否显示表格单选框,
        xuhao: true,//序号显影
        selectReset: null, // 重置单选框选中
        mode: null, // 表格模板one和two两种
        data: [], // 数据
        total: 0, // 总条数
        pager: true, // 是否显示分页
        multipleSelection: [], // 表格单选框数据
        fieldList: [
          { value: "billNo",  label: "付款编号",  show: true, dropdown: true,sortable:true,fixed:'left', width: 110},
          { value: "businessType", label: "类型", show: true, dropdown: true,list:'businessType'},
          { value: "billDate",  label: "申请付款日期",  show: true, dropdown: true,sortable:true, width: 105},
          { value: 'orderBillNo',  label: '结算单号', show: true, dropdown: true, width: 105 },
          { value: 'partnerCode', label: '供应商编号', show: true, dropdown: true },
          { value: 'partnerName', label: '供应商', show: true, dropdown: true },
          { value: 'billRemark', label: '备注', show: true, dropdown: true },
          { value: "button", label: "操作", type: "slot", show: true, dropdown: true, width: 190,fixed:'right',align:'left' },
        ],
        btList: []
      },
      formInfo2: {
        ref: null,
        labelWidth: "112px",
        inline: true,
        data: {
          id:'',
          settleNo:'',
          settleTime:'',
          purMode:'',
          partnerName:'',
          partnerCode:'',
          idCard:'',
          contractId:'',
          materialName:'',
          carNetWeight:'',
          carDeductWeight:'',
          settleQuantity:'',
          settleExctTaxPrice:'',
          settlePrice:'',
          settleExctTaxAmount:'',
          settleAmount:'',
          settleBy:'',
        },
        list: [
          { type: 'text', label: '结算单号：', value: 'settleNo', style: 'width:80%', className: 'form_item_two',disabled:true},
          { type: 'text', label: '结算日期：', value: 'settleTime', style: 'width:80%', className: 'form_item_two',disabled:true},
          {type: "select采购模式：",label: "采购模式：",value: "purMode", style: 'width:80%', className: 'form_item_two',list:'purMode',disabled:true},
          { type: 'text', label: '供应商编号：', value: 'partnerCode', style: 'width:80%', className: 'form_item_two',disabled:true},
          { type: 'text', label: '供应商：', value: 'partnerName', style: 'width:80%', className: 'form_item_two',disabled:true},
          // { type: 'text', label: '身份证：', value: 'idCard', style: 'width:80%', className: 'form_item_two',disabled:true},
          { type: 'text', label: '合同编号：', value: 'contractId', style: 'width:80%', className: 'form_item_two' ,disabled:true},
          { type: 'text', label: '货物品名：', value: 'materialName', style: 'width:80%', className: 'form_item_two' ,disabled:true},
          { type: 'text', label: '到货数量：', value: 'carNetWeight', style: 'width:80%', className: 'form_item_two',disabled:true},
          { type: 'text', label: '扣杂数量：', value: 'carDeductWeight', style: 'width:80%', className: 'form_item_two',disabled:true},
          { type: 'text', label: '结算数量：', value: 'settleQuantity', style: 'width:80%', className: 'form_item_two',disabled:true },
          // { type: 'text', label: '不含税单价：', value: 'settleExctTaxPrice', style: 'width:80%', className: 'form_item_two',disabled:true },
          // { type: 'text', label: '含税单价：', value: 'settlePrice', style: 'width:80%', className: 'form_item_two',disabled:true },
          // { type: 'text', label: '不含税金额：', value: 'settleExctTaxAmount', style: 'width:80%', className: 'form_item_two',disabled:true },
          // { type: 'text', label: '含税金额：', value: 'settleAmount', style: 'width:80%', className: 'form_item_two',disabled:true },
          { type: 'text', label: '制单人：', value: 'settleBy', style: 'width:80%', className: 'form_item_two',disabled:true},
        ],
        rules: {}
      },
        dialogInfoData: {
            visible: false, // 弹框是否显示
            width: '1200px', // 宽度
            title: {
                add: '入库单对应数据', // 标题
            },
            type: 'add', // 显示哪个标题
            // 按钮列表
            btList: [
                { label: '审核', type: 'success', icon: '', event: 'save', loading: false ,show:false},
                { label: '关闭', type: '', icon: '', event: 'close', loading: false }
            ]
        },
    }
  },
  created () {
  },
  mounted () {
    this.$api.dictionary.getSysEnumPage({pageNum: 1, pageSize: 999,enumCategoryCode:'PurMode'}).then(res => {
        if(res.code == 0) {
            let list1 = res.data.list
            for( let i in list1 ) {
                this.listTypeInfo.purMode.push({value: Number(list1[i].enumName), label: list1[i].enumValue})
            }
        }
    })
  },
  methods: {
    dialogShow(data,val,parm,id){
        this.billId = data
        this.dataId = id
        if(parm && parm.id){
          this.auditParm = parm
          this.dialogInfoData.btList[0].show = true
        }else{
          this.dialogInfoData.btList[0].show = false
        }
        this.getInfo(val)
    },
    formatAmount(cellValue) {
      if (typeof cellValue == 'number') {
        cellValue = Number(cellValue.toFixed(2))
        return cellValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }else{
          return cellValue
      }
    },
    // 搜索事件
    getInfo (val) {
      this.$api.system.getActProcessEntryPage({idProcessInstance:this.dataId,pageNum:1,pageSize:999}).then(res => {
          if (res.code == 0) {
              this.activeList = []
              this.activeValue = 0
              for (let i in res.data.list) {
                  if(res.data.list[i].status && i < res.data.list.length){
                      this.activeValue = Number(Number(i) + 1)
                  }
                  let stepStatus = 'process';
                  if (res.data.list[i].status == 1) {
                      stepStatus = 'success';
                  } else if (res.data.list[i].status == 2) {
                      stepStatus = 'error';
                  } else {
                      stepStatus = 'process';
                  }
                  this.activeList.push({
                    processNodeName: res.data.list[i].processNodeName || '', // 第一行：流程节点名称
                    maker: res.data.list[i].status
                      ? res.data.list[i].actualApprover
                      : (res.data.list[i].approver ? res.data.list[i].approver : res.data.list[i].roleName), // 第二行：经办人
                    remark: res.data.list[i].remark || '', // 第三行：备注
                    makerTime: res.data.list[i].approvalTime || '', // 第四行：时间
                    stepStatus
                  })
              }
          }else{
              this.$message({ message: res.msg, type: "error" });
          }
      })
      this.$api.OrderPurchase.getPurArrivalSettleNoPage({settleNo:this.billId,pageNum:1,pageSize:0,ShipStatus:5,settleFlag:1}).then(
        res => {
          if (res.code == 0) {
            if(res.data.list.length > 0){
                this.detailDate = res.data.list[0]
                for (let key in this.formInfo2.data) {
                  this.formInfo2.data[key] = ''
                }
                for (let key in this.detailDate) {
                  if (key in this.formInfo2.data) {
                    this.formInfo2.data[key] = this.detailDate[key];
                  }
                }
                this.$api.report.getArrivalEntryListBySettleNo({settleNo:this.detailDate.settleNo,pageNum:1,pageSize:999}).then(res => {
                  if (res.code == 0) {
                    this.tableData = res.data
                  }else{
                    this.$message({ message: res.msg, type: "error" });
                  }
                })
                if(!val){
                  this.dialogInfoData.visible = true
                }
            } else {
                this.$message({ message: '对应数据查找为空', type: 'warning' })
            }
          }else{
            this.$message({ message: res.msg, type: "error" });
          }
        },
        err => {
          console.log(err)
          this.content.loading = false
        }
      )
    },
    dialogEventData(event){
        const dialogInfoData = this.dialogInfoData
        switch (event) {
            case 'save':
              let parma = this.auditParm
              this.$api.system.approval({id:parma.id,processId:parma.processId,status:parma.status,remark:parma.remark}).then(res => {
                  if (res.code === 0) {
                      this.$message({ message: res.msg, type: 'success' })
                      dialogInfoData.visible = false
                      this.$emit('approvalInfo')
                  } else {
                      this.$message({ message: res.msg, type: 'error' })
                  }
              })
              break
            case 'close':
                dialogInfoData.visible = false
                break
        }
    },
    // 表单内部事件
    formClick (event) {
      switch (event) {
      }
    },
    getSummaries (param) {
      //param 是固定的对象，里面包含 columns与 data参数的对象 {columns: Array[4], data: Array[5]},包含了表格的所有的列与数据信息
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '小计';
          return;
        }
        for(let i=0; i<100;i++){
          if(sums[i]==0){
            sums[i]=''
          }
        }
        const values = data.map(item => Number(item[column.property]));
        if (column.property === 'baseQuantity'|| column.property === 'purMoney' || column.property === 'purExctTaxMoney' || column.property === 'carNetWeight' || column.property === 'carDeductWeight' || column.property === 'settleQuantity' || column.property === 'settleExctTaxAmount' || column.property === 'settleAmount') {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] = sums[index]?this.formatAmount(Number(sums[index].toFixed(3))):'';
        }
      });
      this.$emit('getSummaries', sums)
      return sums;
    },
    previewAvatar(file) { // 查看文件
      window.open(config.pingImgUrl + file.url)
    },
    handlePictureCardPreview (url, value) {
      if(url){
        this.dialogVisible2 = true
        this.dialogImageUrl2 = url
      }
    },
  }
}
</script>
<style lang="stylus" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Custom/WarehousingEntryDialog.vue